const checkTourSession = () => sessionStorage.getItem('isTourStarted')=='YES'

const initialState = Object.freeze({
  is_tour_started: checkTourSession(),
  visible: true,
  resolvers: [],
  promises: [],
  current_step: 0,
  upcoming_step: null,
  skip_steps: [],
  action_type: 'start'
});

const tour = {
    state: {...initialState},
    mutations: {
      ADD_TOUR_SKIP_STEP(state, step) { 
        state.skip_steps = [...state.skip_steps, step]
      },
      RESET_TOUR_PAYLOAD(state) { 
        for(let prop in state) {
          state[prop] = initialState[prop];
        }
        state.is_tour_started = checkTourSession();
      },
      SET_IS_TOUR_STARTED(state, yes) { state.is_tour_started = yes },
      SET_TOUR_VISIBILITY(state, isVisibile) { state.visible = isVisibile },
			SET_TOUR_RESOLVER(state, count=1) {
        const resolvers = [];
        const promises = []
        for(let i=0; i<count; i++) {
          const promise = new Promise((resolve, reject) => {
            resolvers.push({resolve, reject});
          });
          promises.push(promise);
        }
        state.resolvers = resolvers;
        state.promises = promises;
      },
      UPDATE_TOUR_RESOLVER_STATUS(state, {step, message, status}) {
        const p = state.resolvers[step];
        if(status) p.resolve(message);
        else p.reject(message);
      },
      UDATE_CURRENT_TOUR_STEP(state, step) { 
        state.current_step = step;
      },
      UDATE_UPCOMING_TOUR_STEP(state, type) {
        state.action_type = type;
        const curr = state.current_step;
        if('next'==type)
          state.upcoming_step = curr + 1;
        else if('start'==type)
          state.upcoming_step = 0;
        else
          state.upcoming_step = curr - 1;
      }
    },
    actions: {
      setIsTourStarted({state, commit},yes=true) {
        sessionStorage.setItem("isTourStarted",yes?'YES':'NO')
        commit('SET_IS_TOUR_STARTED', yes)
        if(!yes) 
          commit('RESET_TOUR_PAYLOAD');
      }
    },
    getters: {
      isTourStarted: state => state.is_tour_started,
      tour_curr_step: state => state.current_step,
      tour_upcoming_step: state => state.upcoming_step
    }
}

export default tour